<template>
  <div class="page-wrapper">
    <!-- PC 端 -->
    <div class="pc-version">
      <div
        class="page-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <!-- 折叠搜索栏 -->
        <div class="search-bar">
          <el-button
            icon="el-icon-arrow-down"
            type="text"
            @click="toggleSearch"
            style="margin-right: 10px"
          >
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </el-button>

          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              style="width: 180px"
            ></el-input>
            <el-select
              v-model="searchParams.type"
              placeholder="类型"
              clearable
              style="width: 160px"
            >
              <el-option
                v-for="item in typeList"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              ></el-option>
            </el-select>
          </div>

          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button type="primary" icon="el-icon-search" @click="getList">
              搜索
            </el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">
              重置
            </el-button>
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="openAddDialog"
            >
              添加
            </el-button>
            <el-popover
              placement="bottom"
              title="显示列筛选"
              trigger="click"
              width="220"
            >
              <el-checkbox-group v-model="checkedColumns">
                <el-checkbox
                  v-for="item in columnOptions"
                  :key="item.prop"
                  :label="item.prop"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
              <div style="text-align: right; margin-top: 8px">
                <el-button size="mini" @click="handleCheckAll">全选</el-button>
                <el-button size="mini" @click="handleClearAll">清空</el-button>
              </div>
              <el-button slot="reference" icon="el-icon-s-tools" type="info"
                >列筛选</el-button
              >
            </el-popover>
          </div>
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            label="ID"
            prop="id"
            width="100"
            align="center"
            v-if="checkedColumns.includes('id')"
          />
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="140"
            align="center"
            v-if="checkedColumns.includes('user_id')"
          />
         <el-table-column
  label="类型"
  width="120"
  align="center"
  v-if="checkedColumns.includes('type')"
>
  <template slot-scope="scope">
    <span :class="getTypeClass(scope.row.type)">{{ getTypeText(scope.row.type) }}</span>
  </template>
</el-table-column>
          <el-table-column
            label="创建时间"
            prop="created_at"
            width="180"
            align="center"
            v-if="checkedColumns.includes('created_at')"
          />
          <el-table-column
            label="更新时间"
            prop="updated_at"
            width="180"
            align="center"
            v-if="checkedColumns.includes('updated_at')"
          />
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
            v-if="checkedColumns.includes('action')"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click.stop="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- 添加弹窗 -->
        <el-dialog
          title="添加记录"
          :visible.sync="addVisible"
          width="500px"
          append-to-body
        >
          <el-form :model="addForm" label-width="100px" ref="addRef">
            <el-form-item label="用户ID" prop="user_id">
              <el-input
                v-model.number="addForm.user_id"
                placeholder="请输入用户ID"
              />
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-select v-model="addForm.type" placeholder="请选择类型">
                <el-option
                  v-for="item in typeList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="addVisible = false">取消</el-button>
            <el-button
              type="primary"
              :loading="submitLoading"
              @click="submitAdd"
              >确认添加</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="mobile-version">
      <div
        class="mobile-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <div class="mobile-search-group">
          <el-button
            type="text"
            icon="el-icon-arrow-down"
            @click="toggleSearch"
            style="width: 100%; text-align: left; padding-left: 0"
          >
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </el-button>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
            />
            <el-select
              v-model="searchParams.type"
              placeholder="类型"
              clearable
              size="medium"
            >
              <el-option
                v-for="item in typeList"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              />
            </el-select>
          </div>
        </div>
        <div style="display: flex; gap: 8px; margin-bottom: 10px">
          <el-button type="primary" plain round @click="getList" style="flex: 1"
            >搜索</el-button
          >
          <el-button plain round @click="resetSearch" style="flex: 1"
            >重置</el-button
          >
          <el-button
            type="success"
            plain
            round
            @click="openAddDialogMobile"
            style="flex: 1"
            >添加</el-button
          >
        </div>

        <div class="mobile-card-list">
          <div class="mobile-card" v-for="item in tableData" :key="item.id">
            <div class="card-top">
              <div>记录ID：{{ item.id }}</div>
              <div class="type-tag" :class="getTypeClass(item.type)">{{ getTypeText(item.type) }}</div>
            </div>
            <div class="card-info">
              <div>用户ID：{{ item.user_id }}</div>
              <div>创建：{{ item.created_at }}</div>
              <div>更新：{{ item.updated_at }}</div>
            </div>
            <div class="card-btns">
              <el-button
                size="mini"
                type="danger"
                round
                @click.stop="handleDeleteMobile(item)"
                >删除</el-button
              >
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            layout="total, prev, pager, next"
            :total="pageInfo.total"
          />
        </div>

        <!-- 移动端添加弹窗 -->
        <el-dialog
          title="添加记录"
          :visible.sync="addVisibleMobile"
          width="95%"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form :model="addForm" label-width="80px">
            <el-form-item label="用户ID">
              <el-input
                v-model.number="addForm.user_id"
                size="medium"
                placeholder="用户ID"
              />
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="addForm.type" size="medium">
                <el-option
                  v-for="item in typeList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button @click="addVisibleMobile = false">取消</el-button>
            <el-button
              type="primary"
              :loading="submitLoading"
              @click="submitAddMobile"
              >确认</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "WlList",
  data() {
    return {
      loading: false,
      submitLoading: false,
      tableData: [],
      pageInfo: { total: 0 },
      typeList: [],
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
        type: "",
      },
      columnOptions: [
        { label: "ID", prop: "id" },
        { label: "用户ID", prop: "user_id" },
        { label: "类型", prop: "type" },
        { label: "创建时间", prop: "created_at" },
        { label: "更新时间", prop: "updated_at" },
        { label: "操作", prop: "action" },
      ],
      checkedColumns: [
        "id",
        "user_id",
        "type",
        "created_at",
        "updated_at",
        "action",
      ],
      searchCollapsed: true,

      // 弹窗
      addVisible: false,
      addVisibleMobile: false,
      addForm: {
        user_id: "",
        type: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await api.wl.index({ params: this.searchParams });
        if (res.data.code == "1000") {
          this.tableData = res.data.data.data;
          this.pageInfo.total = res.data.data.total;
          this.typeList = res.data.data.type || [];
        }
      } finally {
        this.loading = false;
      }
    },
    getTypeText(t) {
      const item = this.typeList.find((i) => i.type == t);
      return item ? item.desc : "未知";
    },
    getTypeClass(t) {
  // 自行对应type值和样式类，示例三种状态
  const map = {
    1: 'label-blue',
    2: 'label-green',
    3: 'label-red',
  }
  return map[t] || 'label-gray'
},
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
        type: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((i) => i.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },

    // 添加
    openAddDialog() {
      this.addForm = { user_id: "", type: "" };
      this.addVisible = true;
    },
    async submitAdd() {
      if (!this.addForm.user_id || !this.addForm.type)
        return this.$message.warning("请完整填写");
      this.submitLoading = true;
      try {
        await api.wl.add(this.addForm);
        this.addVisible = false;
        this.getList();
      } finally {
        this.submitLoading = false;
      }
    },

    // 删除
    async handleDelete(row) {
      await this.$confirm("确定删除该记录？", "提示", { type: "warning" });
      try {
        await api.wl.del({ record_id: row.id });
        this.getList();
      } catch (err) {
      }
    },

    // 移动端
    openAddDialogMobile() {
      this.addForm = { user_id: "", type: "" };
      this.addVisibleMobile = true;
    },
    async submitAddMobile() {
      if (!this.addForm.user_id || !this.addForm.type)
        return this.$message.warning("请完整填写");
      this.submitLoading = true;
      try {
        await api.wl.add(this.addForm);
        this.addVisibleMobile = false;
        this.getList();
      } finally {
        this.submitLoading = false;
      }
    },
    async handleDeleteMobile(row) {
      await this.$confirm("确定删除？", "提示", { type: "warning" });
      try {
        await api.wl.del({ record_id: row.id });
        this.getList();
      } catch (err) {
      }
    },
  },
};
</script>

<style scoped>
.page-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.label-blue {
  color: #409eff;
  font-weight: 500;
}
.mobile-container {
  padding: 12px;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-weight: 500;
}
.type-tag {
  background: #e8f3ff;
  color: #409eff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
}
.card-info {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-btns {
  display: flex;
  justify-content: flex-end;
}
.label-blue {
  color: #409eff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}
.label-green {
  color: #67c23a;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}
.label-red {
  color: #f56c6c;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}
.label-gray {
  color: #909399;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}
</style>

<style>
@media (max-width: 768px) {
  .pc-version {
    display: none !important;
  }
  .mobile-version {
    display: block !important;
  }
  .mobile-dialog {
    border-radius: 12px !important;
  }
  .mobile-dialog .el-dialog__body {
    padding: 15px !important;
  }
}
@media (min-width: 769px) {
  .pc-version {
    display: block !important;
  }
  .mobile-version {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/log/wl.vue